import Datagent                              from 'datagent';
import {respondData, requestHandle} from '../utils';
import {defaults}                            from 'datagent/src/utils';

const name  = 'industry';
const Model = Datagent.Model({
    name,
    fields : {
        'id'        : {type: Number, default: null},
        'industry'  : {type: String, default: ''}, // 行业名称
    },
    methods: {
        fetch(params={}, opts){
            const { origin } = defaults(opts);
            const { type, limit = 999, ...query } = params
            const url = type == 'listed' ? `${type}Industry` : this._url
            return this.remote(origin).get(`${url}/`, { ...query, limit });
        },
        listedIndustry(params = {}, opts){
            const { origin } = defaults(opts);
            if (typeof params.limit == 'undefined') params.limit = 999
            return this.remote(origin).get(`listedIndustry`, params);
        }
    },
    hooks  : {
        fetch : {after: [respondData(), requestHandle()]},
        listedIndustry : {after: [respondData(), requestHandle()]},
    }
});

Model.ModelName   = name;
export default Model;
